import React from "react";
import { actions, Control } from "react-redux-form";
import { Validators } from "./../common";
import { Errors } from "../../../../../core/atoms/rrf";

interface Props {
  model: string;
  dispatch: any;
}

/**
 * Encapsulate passing HTML5 validation into Redux state
 */
export class EmailField extends React.Component<Props> {
  private inputRef: HTMLInputElement;

  private getModelString = () => `${this.props.model}.email`;

  private onInputBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    if (!this.inputRef.checkValidity) {
      return;
    }

    const isEmailValid = this.inputRef.checkValidity();
    if (isEmailValid) {
      // onInputInvalid is triggered by checkValidity()
      this.props.dispatch(actions.setValidity(this.getModelString(), { emailInvalid: true }));
    }
  }

  /**
   * Triggered by checkValidity() and form submission
   */
  private onInputInvalid = (e: React.SyntheticEvent<HTMLInputElement>) => {
    this.props.dispatch(actions.setValidity(this.getModelString(), { emailInvalid: false }));
  }

  public render() {
    return (
      <label>
        <span className="label">Email address</span>
        <Control.text getRef={x => this.inputRef = x}
                      model=".email"
                      type="email"
                      validators={{ required: Validators.required }}
                      validateOn="blur"
                      onBlur={this.onInputBlur}
                      onInvalid={this.onInputInvalid}
                      autoComplete="email"
                      placeholder="traveller@example.com" />
        <Errors model=".email" messages={{
          required: "Please enter your email address",
          emailInvalid: "Please check your email address",
        }} />
      </label>
    );
  }
}
